import React from 'react'
import { TextField } from '@boltenergy-be/design-system'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'next-i18next/pages'
import { InputProps } from 'components/inputs/types'
import { getFieldError, getFieldName } from 'components/inputs/utils'

const CompanyName = ({ required = true, identifier = 'companyName', parentDotPath }: InputProps) => {
  // React Hook Form
  const {
    formState: { errors },
    register
  } = useFormContext()

  // i18n
  const { t } = useTranslation(['commonFormFields', 'validation', 'common'])

  // Constants
  const fieldKey = getFieldName(identifier, parentDotPath)
  const fieldError = getFieldError(identifier, parentDotPath, errors)

  return (
    <TextField
      {...register(fieldKey, {
        maxLength: {
          value: 255,
          message: t('validation:max.string', {
            attribute: t('commonFormFields:companyName.label'),
            length: 255
          })
        },
        minLength: {
          value: 2,
          message: t('validation:min.string', {
            attribute: t('commonFormFields:companyName.label'),
            length: 2
          })
        },
        required: required ? t('validation:required') : false
      })}
      error={fieldError?.message}
      label={t('commonFormFields:companyName.label')}
      {...(!required && { optionalText: t('common:optional') })}
    />
  )
}

export default CompanyName
